import Image from 'app/Components/Shared/Image/image';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import TextInput from '../../Shared/TextInput/TextInput';
import BtnSubmit from '../../Shared/Buttons/BtnSubmit';
import { validateField, validateForm } from '../../../utilities/validation/formValidation';
import { buildUrlAndOpenSameWindow, navigateTo } from '../../../utilities/StringHelpers/StringHelpers';
import Config from '../../../Config';
import banner from './images/banner.png';
import { showAppLoader, hideAppLoader } from '../../Shared/Loader/LoaderSlice';
import helper from '../../../utilities/helper';
import ProviderManager from './../../../provider/providerManager';
import LeadAgreementsTooltip from '../../Shared/LeadAgreementsTooltip/LeadAgreementsTooltip';
import { useMediaQuery } from '../../../utilities/hooks/useMediaQuery';

const LeadBanner = (props) => {
    const [backgroundHeight, setBackgroundHeight] = useState(null);
    const [backgroundMediaHeight, setBackgroundMediaHeight] = useState(null);
    const [bannerHeight, setBannerHeight] = useState(null);
    const [page, setPage] = useState('leadPage'); //leadPage|successPage|errorPage
    const [formData, setFormData] = useState({
        fullName: { value: '', error: '', validationRules: { required: true, requiredMessage: 'נא הזן שם מלא', regexName: 'lettersRegex', regexMessage: 'שם מלא לא תקין' } },
        phone: { value: '', error: '', validationRules: { required: true, requiredMessage: 'נא הזן טלפון', regexName: 'phoneRegex', regexMessage: 'טלפון לא תקין' } },
    });

    const dispatch = useDispatch();

    //props
    const isMobile = useMediaQuery("(max-width: 440px)");
    const layoutType = getLayoutType(isMobile ? props.iContent.layoutTypeMobile.value : props.iContent.layoutType.value);
    const backgroundImage = (isMobile ? props.iContent.blockBackgroundImageMobile.value?.url : props.iContent.blockBackgroundImage.value?.url);
    const backgroundColor = isMobile ? props.iContent.blockBackgroundColorMobile.value : props.iContent.blockBackgroundColor.value;
    const bannerImage = (isMobile ? props.iContent.bannerImageMobile.value?.url : props.iContent.bannerImage.value?.url);

    const desktopBackgroundMediaIsVideo = props.iContent.desktopBackgroundMedia?.expandedValue?.contentType?.[0]?.toLowerCase()?.includes('video') || props.iContent.desktopBackgroundMedia?.value?.url?.toLowerCase()?.endsWith('.mp4');
    const mobileBackgroundMediaIsVideo = props.iContent.mobileBackgroundMedia?.expandedValue?.contentType?.[0]?.toLowerCase()?.includes('video') || props.iContent.mobileBackgroundMedia?.value?.url?.toLowerCase()?.endsWith('.mp4');
    const backgroundMedia = isMobile ? (mobileBackgroundMediaIsVideo ? props.iContent.mobileBackgroundMedia?.value?.url : null) : (desktopBackgroundMediaIsVideo ? props.iContent.desktopBackgroundMedia?.value?.url : null);

    const formBackgroundColor = isMobile ? props.iContent.formBackgroundColorMobile.value : props.iContent.formBackgroundColor.value;
    const title = isMobile ? props.iContent.titleMobile?.value : props.iContent.title?.value;
    const subTitle = isMobile ? props.iContent.subTitleMobile?.value : props.iContent.subTitle?.value;
    const marketingTitle = isMobile ? props.iContent.marketingTitleMobile?.value : props.iContent.marketingTitle?.value;
    const marketingSubTitle = isMobile ? props.iContent.marketingSubTitleMobile?.value : props.iContent.marketingSubTitle?.value;

    //colors
    const titleColor = isMobile ? props.iContent.titleColorMobile?.value : props.iContent.titleColor?.value;
    const subTitleColor = isMobile ? props.iContent.subTitleColorMobile?.value : props.iContent.subTitleColor?.value;
    const marketingTitleColor = isMobile ? props.iContent.marketingTitleColorMobile?.value : props.iContent.marketingTitleColor?.value;
    const marketingSubTitleColor = isMobile ? props.iContent.marketingSubTitleColorMobile?.value : props.iContent.marketingSubTitleColor?.value;
    const bottomTextColor = isMobile ? props.iContent.bottomTextColorMobile?.value : props.iContent.bottomTextColor?.value;

    //button
    const buttonText = isMobile ? props.iContent.buttonTextMobile?.value : props.iContent.buttonText?.value;
    const buttonTextColor = isMobile ? props.iContent.buttonTextColorMobile?.value : props.iContent.buttonTextColor?.value;
    const buttonBackgroundColor = isMobile ? props.iContent.buttonBackgroundColorMobile?.value : props.iContent.buttonBackgroundColor?.value;

    //success
    const successImage = props.iContent.successImage?.value?.url;
    const successTitle = props.iContent.successTitle?.value;
    const successSubTitle = props.iContent.successSubTitle?.value;
    const successTitleColor = props.iContent.successTitleColor?.value;
    const successSubTitleColor = props.iContent.successSubTitleColor?.value;

    //error
    const errorImage = props.iContent.errorImage?.value?.url;
    const errorTitle = props.iContent.errorTitle?.value;
    const errorTitleColor = props.iContent.errorTitleColor?.value;

    const leadAgreementsData = {
      defaulText: Config.potentialCustomerDefaulText,
      tooltipText: Config.potentialCustomerTooltipText,
      bottomText: Config.potentialCustomerBottomText,
    };

    let bannerStyle = {};
    let backgroundStyle = {};
    let bannerVideo = null;

    // If layoutType is bottom_form_with_banner and backgroundMedia exists, use video for banner
    if (layoutType == 'bottom_form_with_banner' && backgroundMedia) {
        bannerVideo = backgroundMedia;
        bannerStyle = { height: backgroundMediaHeight ? backgroundMediaHeight : null };
    } else if (bannerImage) {
        bannerStyle = { backgroundImage: `url(${Config.epiBaseUrl + bannerImage})`, height: bannerHeight ? bannerHeight : null };
    }

    if (backgroundImage && !backgroundMedia) {
        backgroundStyle = { backgroundImage: `url(${Config.epiBaseUrl + backgroundImage})`, height: backgroundHeight ? backgroundHeight : null };
    }

    if (backgroundMedia && layoutType != 'bottom_form_with_banner') {
        backgroundStyle = { height: backgroundMediaHeight ? backgroundMediaHeight : null };
    }

    if (backgroundColor) {
        backgroundStyle.backgroundColor = backgroundColor;
    }
    // useEffect(() => {
    //     console.info('props.iContent', props.iContent);
    // }, []);

    useEffect(() => {
        if (!backgroundImage) return;
        const img = new window.Image();
        img.onload = () => { setBackgroundHeight(`${img.naturalHeight}px`); };
        img.src = Config.epiBaseUrl + backgroundImage;
        if (img.complete && img.naturalWidth) {
            img.onload();
        }
    }, [backgroundImage]);

    useEffect(() => {
        if (!bannerImage) return;
        const img = new window.Image();
        img.onload = () => { setBannerHeight(`${img.naturalHeight}px`); };
        img.src = Config.epiBaseUrl + bannerImage;
        if (img.complete && img.naturalWidth) {
            img.onload();
        }
    }, [bannerImage]);

    useEffect(() => {
        if (!backgroundMedia) return;
        const video = document.createElement('video');
        video.onloadedmetadata = () => { setBackgroundMediaHeight(`${video.videoHeight}px`); };
        video.src = Config.epiBaseUrl + backgroundMedia;
        video.load();
    }, [backgroundMedia]);

    return (
        <form noValidate id={`form-lead-banner-${props.iContent.contentLink?.id}`} onSubmit={(e)=> e.preventDefault()}>

            <div className={`lead-banner-wrapper ${layoutType}`}>

                {
                    (bannerImage || bannerVideo) && layoutType == 'bottom_form_with_banner' &&
                    <div className='banner-wrapper' style={bannerStyle}>
                        {bannerVideo && (
                            <video
                                className="banner-video"
                                autoPlay
                                loop
                                muted
                                playsInline
                                onLoadedMetadata={(e) => setBackgroundMediaHeight(`${e.target.videoHeight}px`)}
                                style={{
                                    position: 'absolute',
                                    objectFit: 'cover',
                                    top: 0,
                                    left: 0,
                                    zIndex: -1,
                                }}
                            >
                                <source src={Config.epiBaseUrl + bannerVideo} type="video/mp4" />
                            </video>
                        )}
                        <div className='banner-content'>
                            <div className='banner-text-wrapper'>
                                {
                                    marketingTitle &&
                                    <div className='banner-title' dangerouslySetInnerHTML={{ __html: marketingTitle }} style={{ color: marketingTitleColor }}></div>
                                }
                                {
                                    marketingSubTitle &&
                                    <div className='banner-sub-title' dangerouslySetInnerHTML={{ __html: marketingSubTitle }} style={{ color: marketingSubTitleColor }}></div>
                                }
                            </div>
                        </div>
                    </div>
                }

                 <div className='lead-wrapper' style={backgroundStyle}>

                    {backgroundMedia && layoutType != 'bottom_form_with_banner' && (
                        <video
                            className="background-video"
                            autoPlay
                            loop
                            muted
                            playsInline
                            onLoadedMetadata={(e) => setBackgroundMediaHeight(`${e.target.videoHeight}px`)}
                            style={{
                                position: 'absolute',
                                objectFit: 'cover',
                                top: 0,
                                left: 0,
                            }}
                        >
                            <source src={Config.epiBaseUrl + backgroundMedia} type="video/mp4" />
                        </video>
                    )}

                    <div className='marketing-and-form-wrapper'>

                        {
                            (layoutType == 'right_form_with_background' || layoutType == 'left_form_with_background') &&
                            <div className='marketing-wrapper'>
                                {
                                    marketingTitle &&
                                    <div className='marketing-title' dangerouslySetInnerHTML={{ __html: marketingTitle }} style={{ color: marketingTitleColor }}></div>
                                }
                                {
                                    marketingSubTitle &&
                                    <div className='marketing-sub-title' dangerouslySetInnerHTML={{ __html: marketingSubTitle }} style={{ color: marketingSubTitleColor }}></div>
                                }
                            </div>
                        }

                        <div className={`lead-form ${formBackgroundColor ? ' form-with-background' : ''}`} style={{ backgroundColor: formBackgroundColor ? formBackgroundColor : '' }}>
                            {(() => {
                                switch (page) {
                                case 'leadPage':
                                    return getLeadForm();
                                case 'successPage':
                                    return getSuccessPage();
                                case 'errorPage':
                                    return getErrorPage();
                                }
                            })()}
                        </div>

                    </div>

                </div>
            </div>

        </form>
    );

    function getLayoutType(layoutType) {
        if (isMobile) {
            switch (layoutType) {
                case 0: return 'top_form_with_background';
                case 1: return 'form_only';
                case 2: return 'bottom_form_with_banner';
                case 3: return 'bottom_form_with_background';
                default: return 'top_form_with_background';
            }
        }
        else {
            switch (layoutType) {
                case 0: return 'right_form_with_background';
                case 1: return 'form_only';
                case 2: return 'bottom_form_with_banner';
                case 3: return 'left_form_with_background';
                default: return 'right_form_with_background';
            }
        }
    }

    function getLeadForm() {
        return (
            <>

                <div className='lead-title' dangerouslySetInnerHTML={{ __html: title }} style={{ color: titleColor }}></div>
                <div className='lead-sub-title' dangerouslySetInnerHTML={{ __html: subTitle }} style={{ color: subTitleColor }}></div>

                <div className='form-wrapper'>
                    <div className='field-wrapper'>
                        <TextInput
                            value={formData.fullName.value}
                            error={formData.fullName.error}
                            placeholder='שם מלא'
                            id='fullName'
                            name='fullName'
                            type='text'
                            disabled=''
                            required={true}
                            maxLength='50'
                            autoComplete='off'
                            onChange={(e) => handleOnChange('fullName', e.target.value)}
                        />
                    </div>
                    <div className='field-wrapper'>
                        <TextInput
                            value={formData.phone.value}
                            error={formData.phone.error}
                            placeholder='טלפון'
                            id='phone'
                            name='phone'
                            type='tel'
                            disabled=''
                            required={true}
                            maxLength='10'
                            autoComplete='off'
                            onChange={(e) => handleOnChange('phone', e.target.value)}
                        />
                    </div>
                    <div className='button-wrapper'>
                        <BtnSubmit text={buttonText} onclick={handleOnContinue} formid={`form-lead-banner-${props.iContent.contentLink?.id}`} backgroundColor={buttonBackgroundColor} color={buttonTextColor} />
                    </div>
                </div>

                <div className='bottom-text' style={{ color: bottomTextColor }}>
                    <LeadAgreementsTooltip leadAgreementsData={leadAgreementsData} sendTooltipStatus={handleTooltipStatus} />
                </div>
            </>
        );
    }

    function getSuccessPage() {
        return (
            <div className='lead-success-wrapper'>
                <div className='success-icon'> <Image src={Config.epiBaseUrl + successImage} alt='success' /> </div>
                <div className='success-title' style={{ color: successTitleColor }}> {successTitle} </div>
                <div className='success-sub-title' style={{ color: successSubTitleColor }}> {successSubTitle} </div>
            </div>
        );
    }

    function getErrorPage() {
        return (
            <div className='lead-error-wrapper'>
                <div className='error-icon'> <Image src={Config.epiBaseUrl + errorImage} alt='error' /> </div>
                <div className='error-title' style={{ color: errorTitleColor }}> {errorTitle} </div>
                <div className='error-sub-title'> ניתן לפנות לנציג ב-<span>{Config.technicalSupportPhone}</span> </div>
            </div>
        );
    }

    function handleTooltipStatus(toolTipStatus) {
        //setToolTipIsOpen(toolTipStatus);
    }

    function handleOnChange(fieldName, value) {
        let data = formData;
        const error = validateField(data[fieldName].validationRules, value);
        data[fieldName].error = error;
        data[fieldName].value = value;
        setFormData({ ...data });
    }

    function handleOnContinue() {
        const result = validateForm(formData);
        setFormData({ ...result.form });
        if (!result.isValid) { return; }
        createLead();
    }

    async function createLead() {
        try {
            dispatch(showAppLoader());

            const recaptchaToken = '';
            const fullName = formData.fullName.value;
            const phone = formData.phone.value;
            const sfCampaignCode = props.iContent.campaignCode?.value;
            const sfCampaignName = props.iContent.campaignName?.value;
            const sfProductId = props.iContent.productId?.value;
            const adSource = helper.getUrlParameter('source');
            const url = encodeURI(window.location.origin + window.location.pathname);
            const bannerId = helper.getUrlParameter('medium');
            const searchTerm = helper.getUrlParameter('term');
            const isAgreementsCheckBoxActive = true;
            const description = '';
            const customerIdNumber = '';

            const result = await ProviderManager.getProviderData('createLead', [
                recaptchaToken,
                fullName,
                phone,
                sfCampaignCode,
                sfCampaignName,
                sfProductId,
                adSource,
                url,
                bannerId,
                searchTerm,
                isAgreementsCheckBoxActive,
                description,
                customerIdNumber
            ]);

            const isSuccess = result?.Body?.isSuccess;
            setPage(isSuccess ? 'successPage' : 'errorPage');

        } catch (error) {
            setPage('errorPage');
        } finally {
            dispatch(hideAppLoader());
        }
    }

};

export default LeadBanner;
